import services from '@/http'
import * as storage from '../storage'
import * as types from './mutation-types'
import* as home_storage from '../../../pages/home/storage'

export const ActionDoLogin = ({ dispatch }, payload) => {
  return services.auth.login(payload).then(res => {
    dispatch('ActionSetUser', res.data.client)
    dispatch('home/ActionLoadGarage', {id:res.data.client.id}, { root: true })
    dispatch('ActionSetToken', res.data.token)
    
  })
}

export const ActionCheckToken = ({ dispatch, state }) => {
  if (state.token) {
    return Promise.resolve(state.token)
  }

  const token = storage.getLocalToken()

  if (!token) {
    return Promise.reject(new Error('Token Inválido'))
  }

  dispatch('ActionSetToken', token)
  return dispatch('ActionLoadSession',token)
}


export const ActionLoadSession = ({dispatch}, payload) => {
  return services.auth.loadSession({token:payload}).then(res => {
    dispatch('ActionSetUser', res.data.user)
    dispatch('ActionSetToken', res.data.token)
  })
  .catch(err => {
    console.log(err)
    dispatch('ActionSignOut')
  })
}


export const ActionSetUser = ({ commit }, payload) => {
  storage.setLocalUser(payload)
  localStorage.setItem('id_user',payload.id)
  commit(types.SET_USER, payload)
}

export const ActionSetUserLocalStorage = ({ commit }, payload) => {
  commit(types.SET_USER, payload)
}

export const ActionSetTokenLocalStorage = ({ commit }, payload) => {
  storage.setHeaderToken(payload)
  commit(types.SET_TOKEN, payload)
}

export const ActionSetToken = ({ commit }, payload) => {
  storage.setLocalToken(payload)
  storage.setHeaderToken(payload)
  commit(types.SET_TOKEN, payload)
}

export const ActionSignOut = ({ dispatch }) => {
  storage.setHeaderToken('')
  storage.deleteLocalToken()
  storage.deleteLocalUser()
  storage.deleteLocalUserId()
  home_storage.deleteCredito()
  home_storage.deleteCarSelected()
  localStorage.removeItem('garage_selected')
  localStorage.removeItem('choiced_product')
  localStorage.removeItem('id_user')
  home_storage.deleteGarage()
  home_storage.deleteDataAtualizacaoCredito()
  dispatch('ActionSetUser', {})
  dispatch('ActionSetToken', '')

}
